import { Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from './context/ThemeProvider'
import { Toaster, toast } from 'sonner'
import { useEffect } from 'react'

import SaiMessagingCenter from './pages/Admin/SAI/MessagingCenter'
import ImpersonateRedirect from './pages/ImpersonateRedirect'
import SaiStaffDetails from './pages/Admin/SAI/StaffDetails'
import AccountSettings from './pages/Admin/AccountSettings'
import OHRequestForm from './components/OHRequestForm.js'
import OHRequestPage from './components/OHRequestPage.js'
import QuoteDetails from './pages/Admin/SAI/QuoteDetails'
import CreateClaim from './pages/Admin/SAI/CreateClaim'
import SaiDashboard from './pages/Admin/SAI/Dashboard'
import OhDashboard from './pages/Admin/OH/Dashboard'
import SaiAccounts from './pages/Admin/SAI/Accounts'
import SaiHolidays from './pages/Admin/SAI/Holidays'
import PersistLogin from './components/PersistLogin'
import ForgotPassword from './pages/ForgotPassword'
import CreatePassword from './pages/CreatePassword'
import RequireAuth from './components/RequireAuth'
import ResetPassword from './pages/ResetPassword'
import AccountSelect from './pages/AccountSelect'
import SaiClaims from './pages/Admin/SAI/Claims'
import CheckLogin from './components/CheckLogin'
import Dashboard from './pages/Admin/Dashboard'
import AuthLayout from './layouts/AuthLayout'
import OhLayout from './layouts/OhLayout'
import Layout from './components/Layout'
import Missing from './pages/Missing'
import TwoFa from './pages/TwoFactor'
import Login from './pages/Login'

import Clarity from '@microsoft/clarity'
import Quotes from './pages/Admin/SAI/Quotes'
import PolicyInfo from './pages/Admin/SAI/PolicyInfo'

function App() {
  const projectId = 'ogftd8bkpx'
  Clarity.init(projectId)

  useEffect(() => {
    const interval = setInterval(() => {
      const expiry = localStorage.getItem('impersonating_expire')
      if (expiry) {
        const expiryTime = new Date(expiry).getTime()
        if (Date.now() >= expiryTime) {
          console.info(
            'Impersonation expired, removing items from localStorage'
          )
          localStorage.removeItem('impersonating_expire')
          localStorage.removeItem('impersonating')
          window.location.reload()
        }
      }
    }, 1000 * 60)

    return () => clearInterval(interval)
  }, [])

  return (
    <ThemeProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Public Routes */}
          <Route element={<PersistLogin />}>
            {/* Routes for logged-in users */}
            <Route element={<RequireAuth />}>
              <Route element={<AuthLayout />}>
              
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="account-select" element={<AccountSelect />} />
                <Route
                  path="/users/:id/account-settings"
                  element={<AccountSettings />}
                />
                <Route path="sai/dashboard" element={<SaiDashboard />} />
                <Route path="sai/claims" element={<SaiClaims />} />
                <Route path="sai/claims/new" element={<CreateClaim />} />
                <Route path="sai/staff-details" element={<SaiStaffDetails />} />
                <Route path="sai/holidays" element={<SaiHolidays />} />
                <Route path="sai/accounts" element={<SaiAccounts />} />
                <Route path="sai/messages" element={<SaiMessagingCenter />} />
                <Route path="sai/quotes" element={<Quotes />} />
                <Route path="sai/policy-information" element={<PolicyInfo />} />
                <Route path="sai/quote-details/:quoteType" element={<QuoteDetails />} />
              </Route>
              <Route element={<OhLayout />}>
                <Route path="oh/dashboard" element={<OhDashboard />} />
                <Route path="oh/oha-request" element={<OHRequestPage />} />
              </Route>
            </Route>

            {/* Routes for logged-out users */}
            <Route element={<CheckLogin />}>
              <Route element={<AuthLayout />}>
                <Route path="/" element={<Login />} />
                <Route path="login" element={<Navigate to="/" replace />} />
                <Route path="2fa" element={<TwoFa />} />
                <Route path="password/forgot" element={<ForgotPassword />} />
                <Route path="password/reset" element={<ResetPassword />} />
                <Route
                  path="password/create/:token"
                  element={<CreatePassword />}
                />
              </Route>
            </Route>
            {/* Catch All */}
            <Route path="impersonate" element={<ImpersonateRedirect />} />
            <Route path="*" element={<Missing />} />
          </Route>
        </Route>
      </Routes>
      <Toaster richColors />
    </ThemeProvider>
    
  )
}

export default App
